
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getCompanyDtl, jump2Quota, jump2Repayment, toQuotaResDto } from '@/api/customerManage'
import { openNewPage } from '@/utils/h5ToApp'
import { getSyDictDataInfo, updateUserOtherInfoFCD } from '@/api/commonConfig'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'Authorize',
  components: {}
})
export default class Authorize extends Vue {
  @Getter companyId!: string
  @Getter mobile!: string
  @Getter userId!: string

  type = 1 // 操作类型 1:'去出额' , 2:'去借款', 3:'去还款'
  merchantId = '' // 选中的客户编号
  companyName = '' // 当前公司名称
  times = 5 // 倒计时

  today = new Date()

  nowDate = (this.today.getFullYear()) + '年' + (this.today.getMonth() + 1) + '月' + this.today.getDate() + '日' + ' '

  created () {
    this.type = Number(this.$route.query.type)
    this.merchantId = this.$route.query.merchantId as string

    this.timesFun()
    this.getCompanyInfo()
  }

  beforeRouteEnter (to, from, next) {
    next(vm => {
      getSyDictDataInfo({dictTypeId: 'tradeSignTime'}).then((res: any) => {
        vm.times = res.data[0].dataId || 1
      })
    })
  }

  timesFun () {
    let timeIn = setInterval(() => {
      this.times--
      if (this.times === 0) {
        clearInterval(timeIn)
      }
    }, 1000)
  }

  /**
   * @description: 获取公司信息
   * @param {*}
   * @return {*}
   */
  getCompanyInfo () {
    getCompanyDtl({companyId: this.companyId}).then(res => {
      this.companyName = res.data.companyName
    })
  }


  sureFunc () {
    //  跳转个人信息使用授权书页面
    updateUserOtherInfoFCD({userId:this.userId}).then((res)=>{
      if(res.code==='000000'){
        this.$router.push({
          path: '/financialServices',
        })
      }else {
        this.$toast('个人信息授权失败')
      }
    })
  }

  /**
   * 去出额
   * @param isAuthorized 是否授权，默认false
   */
  toQuota () {
    const obj = {
      companyId: this.companyId,
      merchantId: this.merchantId
      // isAuthorized: true
    }
    jump2Quota(obj).then((res) => {
      if (res.code === '000000') {
        //    跳转到免登录产融h5
        this.toFreeLogin(res.data)
      }
    })
  }

  /**
   * 跳转到免登录页面
   * @param data 后端接口返回数据
   */
  toFreeLogin (data: toQuotaResDto) {
    // let redirectUrl = 'http://172.16.101.69:8088/#/loginFree?as=CYTCS001&cs=1000&orderId=24b3bf8c-1570-455f-9da8-7b33efe62283&client=0&industryType='
    openNewPage({url: encodeURI(data.redirectUrl)})
  }
}
